module.exports = "/assets/data/fa4755a35df3359c004c25faaf475af2-BT3.data.json";